module.exports = __webpack_public_path__ + "static/media/decentralized.ae17e08a.svg";